module.exports = __webpack_public_path__ + "static/media/pikto_testczujnosci.66627224.png";